import styled from "styled-components";

const StepCustom = styled.div`
  background-color: ${({ color }) => color};
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center; /* Corrigido aqui */
  font-size: 12px;
  color: #fff;
`;

const StepIconCustom = ({ color, children }) => {
  return <StepCustom color={color}>{children}</StepCustom>;
};

export default StepIconCustom;
